import { useEffect, useState } from 'react';
import type { PokemonV2 } from './pokemon';
import { getAllPokemonList, loadPokemonList } from './pokemon';

export const usePokemonList = () => {
  // 既にキャッシュがあれば初期表示に反映して空表示を避ける
  const [pokemonList, setPokemonList] = useState<PokemonV2[]>(getAllPokemonList());
  const [isLoading, setIsLoading] = useState<boolean>(pokemonList.length === 0);

  useEffect(() => {
    // アンマウント後のsetStateを防ぐためのフラグ
    let canceled = false;
    loadPokemonList()
      .then((list) => {
        if (canceled) {
          return;
        }
        setPokemonList(list);
        setIsLoading(false);
      })
      .catch((error) => {
        if (canceled) {
          return;
        }
        console.error('Failed to load pokemon master data:', error);
        setIsLoading(false);
      });

    return () => {
      canceled = true;
    };
  }, []);

  return { pokemonList, isLoading };
};
